const mutations = {
  setSponsors(state, payload) {
    state.sponsors = payload
  },
  addSponsor(state, payload) {
    state.sponsors.push(payload);
  },
  deleteSponsor(state, payload) {
    state.sponsors = state.sponsors.filter(sponsor => {
      return sponsor.id !== payload;
    });
  },
  updateSponsors(state, payload) {
    let index = state.sponsors.findIndex(item => {
      return item.id === payload.id;
    });
    Object.keys(payload).map(key => {
      state.sponsors[index][key] = payload[key];
    });
  },
};

export default mutations;
